.linkWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spasing04);

  .icon {
    svg {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
    }
  }
}
